import { Button, Icon } from "semantic-ui-react";

import { DayplannerStatusOptions } from "modules/Dayplanner/utils";

import type { DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS } from "models";

export type DayplannerStatusDataType = {
  icon: string;
  value: DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS;
  isActive: boolean;
  color: string;
};

type StatusFilterProps = {
  statuses: DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS[];
  onSelect: (status: DayplannerStatusDataType[]) => void;
};

export const dayplannerStatusOptions: DayplannerStatusDataType[] = [...DayplannerStatusOptions.entries()].map(([value, { color, icon }]) => ({
  icon,
  value,
  isActive: false,
  color
}));

export const DayplannerStatuses = ({ onSelect, statuses }: StatusFilterProps) => {
  const currentDayplannerOptions = dayplannerStatusOptions.map(item => ({ ...item, isActive: statuses.includes(item.value) }));

  const handleClick = (index: number) => {
    const matchingIdentifier = currentDayplannerOptions[index];

    const updatedSelectedStatusIdentifiersFilters = currentDayplannerOptions.with(index, { ...matchingIdentifier, isActive: !matchingIdentifier.isActive });
    onSelect(updatedSelectedStatusIdentifiersFilters);
  };

  return (
    <div className="status-filters-wrapper">
      {currentDayplannerOptions.map((item, index) => {
        return (
          <div key={`filter-status-${index}`} className="StatusFilters-buttons" onClick={() => handleClick(index)}>
            <Button color="orange" className="af" style={{ backgroundColor: item.color }} disabled={!item.isActive}>
              {item.icon === "bo" ? <span style={{ color: "black" }}>BO</span> : <Icon className={item.icon} color="black" />}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
